// Copyright (c) 2017 Deere & Company

import {combineReducers} from 'redux';
import {getCombinedReducers as getCombinedAuditsReducers} from './audits/reducers';
import {getCombinedReducers as getCombinedClaimDebitReducers} from './claim-debit/reducers';
import {getCombinedReducers as getCombinedClaimSearchReducers} from './claim-search/reducers';
import {getCombinedReducers as getCombinedLaborRateReducers} from './labor-rate-approval/reducers';
import {getCombinedReducers as getCombinedPartialDebitReducers} from './partial-debit/reducers';
import {getCombinedReducers as getCombinedPercentageDebitReducers} from './percentage-debit/reducers';
import {getCombinedReducers as getCombinedPrepareAuditReducers} from './prepare-audit/reducers';
import {getCombinedReducers as getCombinedRecordAuditReducers} from './record-audit/reducers';
import {getCombinedReducers as getCombinedSpaDetailsReducers} from './spa-details/reducers';
import {getCombinedReducers as getCombinedWipReducers} from './wip/reducers';

export const getCombinedReducers = () => combineReducers({
    addClaimsToAudit: getCombinedClaimSearchReducers(),
    audits: getCombinedAuditsReducers(),
    claimDebit: getCombinedClaimDebitReducers(),
    laborRateApproval: getCombinedLaborRateReducers(),
    partialDebit: getCombinedPartialDebitReducers(),
    percentageDebit: getCombinedPercentageDebitReducers(),
    prepareAudit: getCombinedPrepareAuditReducers(),
    recordAudit: getCombinedRecordAuditReducers(),
    spaDetails: getCombinedSpaDetailsReducers(),
    wip: getCombinedWipReducers()
});



// WEBPACK FOOTER //
// ./src/tcsm/tcsm-reducers.js